const passwordMinLength = 8;

export const passwordValidatorMessage = `Пароль должен содержать латинские буквы и цифры. Минимальная длина пароля - ${passwordMinLength} символов`;

export const passwordValidator = (value: any): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  // Must contain numbers
  if (!value.replace(/\D/g, '').length) {
    return false;
  }
  // Must contain latin letters
  if (!value.replace(/[^a-zA-Z]/g, '').length) {
    return false;
  }
  // Must contain only numbers, latin letters and special characters
  // eslint-disable-next-line no-useless-escape
  if (value.replace(/[\da-zA-Z!@#\$%\^\&*\)\(+=.,<>{}\[\]_-]/g, '').length) {
    return false;
  }
  return value.length >= passwordMinLength;
};
